/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    HomeAnswerHomeData,
    HomeAnswerHomeDataFromJSON,
    HomeAnswerHomeDataFromJSONTyped,
    HomeAnswerHomeDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface HomeAnswer
 */
export interface HomeAnswer {
    /**
     * 
     * @type {HomeAnswerHomeData}
     * @memberof HomeAnswer
     */
    homeData?: HomeAnswerHomeData;
}

export function HomeAnswerFromJSON(json: any): HomeAnswer {
    return HomeAnswerFromJSONTyped(json, false);
}

export function HomeAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'homeData': !exists(json, 'home-data') ? undefined : HomeAnswerHomeDataFromJSON(json['home-data']),
    };
}

export function HomeAnswerToJSON(value?: HomeAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'home-data': HomeAnswerHomeDataToJSON(value.homeData),
    };
}


